import api from "./Api";

class ConfiguracaoWhiteLabelService {
  GetConfiguracaoWhiteLabel(payload) {
    return api.get("/v1/configuracaoWhiteLabel/" + payload).then((response) => {
      return response.data;
    });
  }

  PostConfiguracaoWhiteLabel(payload) {
    return api.post("/v1/configuracaoWhiteLabel/", payload).then((response) => {
      return response.data;
    });
  }

  PutConfiguracaoWhiteLabel(payload) {
    return api.put("/v1/configuracaoWhiteLabel/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteConfiguracaoWhiteLabel(payload) {
    return api
      .delete("/v1/configuracaoWhiteLabel/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetConfiguracaoWhiteLabelOData(payload) {
    return api
      .get("/OData/ConfiguracaoWhiteLabel" + payload)
      .then((response) => {
        return response.data;
      });
  }

  CarregarUrl(payload) {
    return api
      .get("/v1/ConfiguracaoWhiteLabel/CarregarUrl/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostConfiguracaoWhiteLabelUpload(payload) {
    return api
      .post("/v1/configuracaoWhiteLabelUpload/", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new ConfiguracaoWhiteLabelService();
